import { useContext } from "react";
import AppContext from "../../context/AppContext";
import ReactSelector from "./CommonReactSelector";

export const PAGE_SIZE_OPTIONS = [
  { value: 10, label: "10" },
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
];

const PageSizeSelector = ({
  value,
  onChange,
  disabled = false,
  className = "",
  height = "36px",
  fontSize = "14px",
  width = "w-[64px] sm:w-[72px]",
}) => {
  const { theme } = useContext(AppContext);
  const textColor = theme === "high-contrast" ? "#ffffff" : theme === "dark" ? "#f1f5f9" : "#111827";

  const handleChange = (selected) => {
    if (selected?.value != null) {
      onChange(selected.value);
    }
  };

  return (
    <div className={`${width} shrink-0 ${className}`.trim()}>
      <ReactSelector
        value={PAGE_SIZE_OPTIONS.find((item) => item.value === value) ?? PAGE_SIZE_OPTIONS[0]}
        options={PAGE_SIZE_OPTIONS}
        onChange={handleChange}
        height={height}
        fontSize={fontSize}
        isClearable={false}
        isSearchable={false}
        hideSearch
        isDisabled={disabled}
        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        forceLtr
        styles={{
          control: () => ({
            minWidth: 0,
            cursor: disabled ? "not-allowed" : "pointer",
          }),
          valueContainer: () => ({
            padding: "0 4px 0 8px",
          }),
          singleValue: () => ({
            color: textColor,
            opacity: 1,
            visibility: "visible",
          }),
          input: () => ({
            color: "transparent",
            caretColor: "transparent",
          }),
          menuList: () => ({
            paddingTop: "4px",
            paddingBottom: "4px",
          }),
          option: () => ({
            textAlign: "left",
            padding: "8px 10px",
          }),
        }}
      />
    </div>
  );
};

export default PageSizeSelector;
